import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Typography,
  Alert as MuiAlert,
  TextField,
  MenuItem,
  CircularProgress
} from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  FileUpload,
  FileDownload,
  Error,
  Verified,
  CheckCircle,
  InsertDriveFileOutlined,
  InfoOutlined
} from '@mui/icons-material'
import React, { useEffect, useState, forwardRef, useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import _ from 'lodash'
import ImportDialog from './bulkItemUpload/importDailog'
import {
  ConfirmationDialog,
  ExportScreen,
  ImportScreen,
  SnackBarHideDuration,
  SnackBarTransition
} from '../../utils/ui_utils'
import * as XLSX from 'xlsx'
import FileExportDialog from './bulkItemUpload/exportDialog'
import FileImportDialog from './bulkItemUpload/fileImportDailog'
import ListTypeShimmer from '../../utils/ui_components/shimmers/listTypeShimmer'
import { useFetchItems, useImportItems } from '../../modules/items/itemsHooks'
import {
  useFetchKitchenCounters,
  useImportKitchenCounter
} from '../../modules/kitchenCounters/kitchenCountersHooks'
import {
  useFetchCounterGroups,
  useImportCounterGroup
} from '../../modules/counterGroup/counterGroupsHooks'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import { useTerminalSettingsFetch } from '../../modules/terminalSettings/terminalSettingsHooks'
import { useDispatch } from 'react-redux'
import {
  clearAllCounterGroupsState,
  clearCounterGroupsState
} from '../../modules/counterGroup/counterGroupsSlice'
import { clearKitchenCounterState } from '../../modules/kitchenCounters/kitchenCountersSlice'
import { clearItemsState } from '../../modules/items/itemsSlice'

function bulkUpload() {
  const [pageCounterGroup, setPageCounterGroup] = useState(1)
  const [pageCounter, setPageCounter] = useState(1)
  const [pageItem, setPageItem] = useState(1)
  const [limit, setLimit] = useState(100)
  const [item, setItem] = useState(undefined)
  const [itemDrawerVisibility, setItemsDrawerVisibility] = useState(false)
  const [fileImportVisibility, setFileImportVisibility] = useState(false)
  const [fileExportVisibility, setFileExportVisibility] = useState(false)
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [itemsData, setItemsData] = useState([])
  const [outlets, setOutlets] = useState([])
  const [userdata, setUserData] = useState(undefined)
  const [stockUpdateDailog, setStockUpdateDailog] = useState(false)
  const [stockUpdateStatus, setStockUpdateStatus] = useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [counterGroupFile, setCounterGroupFile] = useState(
    'CounterGroups.csv importing...'
  )
  const [counterFile, setCounterFile] = useState('Counters.csv importing...')
  const [itemFile, setItemFile] = useState('Items.csv importing...')
  const [counterGroupMsg, setCounterGroupMsg] = useState(null)
  const [counterMsg, setCounterMsg] = useState(null)
  const [itemMsg, setItemMsg] = useState(null)
  const [counterGroupFileExport, setCounterGroupFileExport] = useState(
    'CounterGroups.csv exporting...'
  )
  const [counterFileExport, setCounterFileExport] = useState(
    'Counters.csv exporting...'
  )
  const [itemFileExport, setItemFileExport] = useState('Items.csv exporting...')
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)
  const [exportSubmitButtonDisabled, setExportSubmitButtonDisabled] =
    useState(null)
  const [statusIconCG, setStatusIconCG] = useState(
    <CircularProgress size={20} />
  )
  const [statusIconC, setStatusIconC] = useState(<CircularProgress size={20} />)
  const [statusIconItem, setStatusIconItem] = useState(
    <CircularProgress size={20} />
  )
  const [statusIconCGExport, setStatusIconCGExport] = useState(
    <CircularProgress size={20} />
  )
  const [statusIconCExport, setStatusIconCExport] = useState(
    <CircularProgress size={20} />
  )
  const [statusIconItemExport, setStatusIconItemExport] = useState(
    <CircularProgress size={20} />
  )
  const [selectedFolder, setSelectedFolder] = useState(null)
  const [fileStatusIconCG, setFileStatusIconCG] = useState(
    <Verified fontSize="small" color="primary" sx={{ alignItems: 'center' }} />
  )
  const [fileStatusIconC, setFileStatusIconC] = useState(
    <Verified fontSize="small" color="primary" sx={{ alignItems: 'center' }} />
  )
  const [fileStatusIconItem, setFileStatusIconItem] = useState(
    <Verified fontSize="small" color="primary" sx={{ alignItems: 'center' }} />
  )
  const [backButtonDisabled, setBackButtonDisabled] = useState(true)
  const [json_CounterGroup, setJson_CounterGroups] = useState([])
  const [json_Counter, setJson_Counter] = useState([])
  const [json_Item, setJson_Item] = useState([])
  const [counterGroupsArray, setCounterGroupsArray] = useState([])
  const [countersArray, setCountersArray] = useState([])
  const [itemArray, setItemArray] = useState([])
  const [exportDataStatus, setExportDataStatus] = useState(false)

  const { fetchItems, fetchItemsData } = useFetchItems()
  const { importItemsCsv } = useImportItems()
  const { kitchenCountersData, kitchenCountersFetch } =
    useFetchKitchenCounters()
  const { kitchenCountersImport } = useImportKitchenCounter()
  const { fetchCounterGroups, fetchCounterGroupsData } = useFetchCounterGroups()
  const { importCounterGroup } = useImportCounterGroup()
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const { terminalSettingsFetch, terminalSettingsFetchData } =
    useTerminalSettingsFetch()
  const dispatch = useDispatch()
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const history = useNavigate()
  useEffect(() => {
    dispatch(clearCounterGroupsState())
    dispatch(clearAllCounterGroupsState())
    dispatch(clearKitchenCounterState())
    dispatch(clearItemsState())
    fetchOutlet()
  }, [])

  const checkFileType = (file, fileNames) => {
    try {
      const fileName = file.name
      return fileNames.some((name) => fileName === name)
    } catch (error) {
      return false
    }
  }

  const fetchOutlet = () => {
    businessCheck(history)
    let payload = {
      pageNumber: 1,
      limit: 1000
    }
    outletFetch(payload)
  }

  useLayoutEffect(() => {
    if (fetchCounterGroupsData?.total != undefined) {
      if (fetchCounterGroupsData.data?.length > 0) {
        const json = fetchCounterGroupsData.data
        const refinedJson = json.map(
          ({ name: CounterGroup_Name, ...rest }) => ({
            'CounterGroup Name': CounterGroup_Name,
            Id: `"${rest._id}"`
          })
        )
        setCounterGroupsArray((prevArray) => {
          const seen = new Set(prevArray.map((r) => r.Id))
          return [...prevArray, ...refinedJson.filter((r) => !seen.has(r.Id))]
        })
      } else if (exportDataStatus) {
        let json = [
          {
            'CounterGroup Name': '',
            Id: ''
          }
        ]
        const worksheet = XLSX.utils.json_to_sheet(json)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        XLSX.writeFile(workbook, 'CounterGroups.csv', { compression: true })
        setCounterGroupFileExport('CounterGroups.csv exported successfully')
        setStatusIconCGExport(<CheckCircle fontSize="small" color="success" />)
        setExportSubmitButtonDisabled(false)
      }
    }
  }, [fetchCounterGroupsData.data])

  useEffect(() => {
    if (counterGroupsArray.length > 0) {
      let nextPage = pageCounterGroup + 1
      let total_Pages = Math.ceil(fetchCounterGroupsData?.total / limit)
      if (total_Pages < nextPage) {
        try {
          const worksheet = XLSX.utils.json_to_sheet(counterGroupsArray)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          XLSX.writeFile(workbook, 'CounterGroups.csv', { compression: true })
          setCounterGroupFileExport('CounterGroups.csv exported successfully')
          setStatusIconCGExport(
            <CheckCircle fontSize="small" color="success" />
          )
        } catch (err) {
          setExportSubmitButtonDisabled(false)
          setStatusIconCGExport(<Error fontSize="small" color="error" />)
        }
      }
      if (total_Pages >= nextPage) {
        setPageCounterGroup(nextPage)
        let payload = {
          outlet_id: selectedOutlet,
          pageNumber: nextPage,
          limit: limit
        }
        fetchCounterGroups(payload)
      }
    }
  }, [counterGroupsArray])

  useLayoutEffect(() => {
    if (kitchenCountersData?.total != undefined) {
      if (kitchenCountersData.data?.length > 0) {
        const json = kitchenCountersData.data
        const refinedJson = json.map(
          ({
            counter_group: { name: CounterGroup_Name },
            name: kitchenCounters_Name,
            printer_number,
            ...rest
          }) => ({
            'CounterGroup Name': CounterGroup_Name,
            'KitchenCounters Name': kitchenCounters_Name,
            'Printer Number': printer_number,
            Id: `"${rest._id}"`
          })
        )
        setCountersArray((prevArray) => {
          const seen = new Set(prevArray.map((r) => r.Id))
          return [...prevArray, ...refinedJson.filter((r) => !seen.has(r.Id))]
        })
      } else if (exportDataStatus) {
        let json = [
          {
            'CounterGroup Name': '',
            'KitchenCounters Name': '',
            'Printer Number': '',
            Id: ''
          }
        ]
        const worksheet = XLSX.utils.json_to_sheet(json)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        XLSX.writeFile(workbook, 'Counters.csv', { compression: true })
        setCounterFileExport('Counters.csv exported successfully')
        setStatusIconCExport(<CheckCircle fontSize="small" color="success" />)
        setExportSubmitButtonDisabled(false)
      }
    }
  }, [kitchenCountersData.data])

  useEffect(() => {
    if (countersArray.length > 0) {
      let nextPage = pageCounter + 1
      let total_Pages = Math.ceil(kitchenCountersData?.total / limit)
      if (total_Pages < nextPage) {
        try {
          const worksheet = XLSX.utils.json_to_sheet(countersArray)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          XLSX.writeFile(workbook, 'Counters.csv', { compression: true })
          setCounterFileExport('Counters.csv exported successfully')
          setStatusIconCExport(<CheckCircle fontSize="small" color="success" />)
        } catch (err) {
          setExportSubmitButtonDisabled(false)
          setStatusIconCExport(<Error fontSize="small" color="error" />)
        }
      }
      if (total_Pages >= nextPage) {
        setPageCounter(nextPage)
        let payload = {
          outlet_id: selectedOutlet,
          pageNumber: nextPage,
          limit: limit
        }
        kitchenCountersFetch(payload)
      }
    }
  }, [countersArray])

  useLayoutEffect(() => {
    if (fetchItemsData?.total != undefined) {
      if (fetchItemsData.data?.length > 0) {
        const json = fetchItemsData.data
        const refinedJson = json.map(
          ({
            _id,
            name,
            sku: SKU,
            price,
            unit: Unit,
            parcel_amt,
            kitchen_counter: { name: Kitchen_Counter },
            ...rest
          }) => ({
            'Item Name': name,
            SKU,
            'Cost Price': price.find(({ price_id }) => price_id === 1)
              .cost_price,
            Unit,
            'Parcel Charge': parcel_amt,
            Price1: price.find(({ price_id }) => price_id === 1).unit_price,
            SGST1: price.find(({ price_id }) => price_id === 1).sgst,
            CGST1: price.find(({ price_id }) => price_id === 1).cgst,
            Price2: price.find(({ price_id }) => price_id === 2).unit_price,
            CGST2: price.find(({ price_id }) => price_id === 2).cgst,
            SGST2: price.find(({ price_id }) => price_id === 2).sgst,
            Price3: price.find(({ price_id }) => price_id === 3).unit_price,
            CGST3: price.find(({ price_id }) => price_id === 3).cgst,
            SGST3: price.find(({ price_id }) => price_id === 3).sgst,
            Cess1: price.find(({ price_id }) => price_id === 1).cess1,
            Cess2: price.find(({ price_id }) => price_id === 1).cess2,
            'Kitchen Counter': Kitchen_Counter,
            Imagepath: Object.prototype.hasOwnProperty.call(rest, 'image_path')
              ? rest.image_path
              : '',
            Stock: 0,
            'Maintain Inventory': rest.maintain_inventory ? 1 : 0,
            'Weighing Scale Code': rest.weighing_scale_code,
            'Is Favorite': rest.is_favorite ? 1 : 0,
            'Priority(0,1,2,3,4,5)': rest.priority || 0,
            Commission: rest.commission || 0,
            Id: `"${_id}"`
          })
        )
        setItemArray((prevArray) => {
          const seen = new Set(prevArray.map((r) => r.Id))
          return [...prevArray, ...refinedJson.filter((r) => !seen.has(r.Id))]
        })
      } else if (exportDataStatus) {
        let json = [
          {
            'Item Name': '',
            SKU: '',
            'Cost Price': '',
            Unit: '',
            'Parcel Charge': '',
            Price1: '',
            SGST1: '',
            CGST1: '',
            Price2: '',
            CGST2: '',
            SGST2: '',
            Price3: '',
            CGST3: '',
            SGST3: '',
            Cess1: '',
            Cess2: '',
            'Kitchen Counter': '',
            Imagepath: '',
            Stock: '',
            'Maintain Inventory': '',
            'Weighing Scale Code': '',
            'Is Favorite': '',
            'Priority(0,1,2,3,4,5)': '',
            Commission: '',
            Id: ''
          }
        ]
        const worksheet = XLSX.utils.json_to_sheet(json)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        XLSX.writeFile(workbook, 'Items.csv', { compression: true })
        setItemFileExport('Items.csv exported successfully')
        setStatusIconItemExport(
          <CheckCircle fontSize="small" color="success" />
        )
        setExportSubmitButtonDisabled(false)
        setExportDataStatus(false)
      }
    }
  }, [fetchItemsData.data])

  useEffect(() => {
    if (itemArray.length > 0) {
      let nextPage = pageItem + 1
      let total_Pages = Math.ceil(fetchItemsData?.total / limit)
      if (total_Pages < nextPage) {
        try {
          const worksheet = XLSX.utils.json_to_sheet(itemArray)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          XLSX.writeFile(workbook, 'Items.csv', { compression: true })
          setItemFileExport('Items.csv exported successfully')
          setStatusIconItemExport(
            <CheckCircle fontSize="small" color="success" />
          )
          setExportSubmitButtonDisabled(false)
        } catch (err) {
          setStatusIconItemExport(<Error fontSize="small" color="error" />)
          setExportSubmitButtonDisabled(false)
        }
      }
      if (total_Pages >= nextPage) {
        setPageItem(nextPage)
        let payload = {
          outlet_id: selectedOutlet,
          pageNumber: nextPage,
          limit: limit
        }
        fetchItems(payload)
      }
    }
  }, [itemArray])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data)
      setSelectedOutlet(outletFetchData.data[0]._id)
      setSelectedOutletName(outletFetchData.data[0].name)
      terminalSettingsFetch(outletFetchData.data[0]._id)
    } else {
      setOutlets([])
      setSelectedOutlet('')
      setSelectedOutletName('')
    }
  }, [outletFetchData.data])

  const handleOutletChange = (event) => {
    setItemsData([])
    setSelectedOutlet(event.target.value)
    terminalSettingsFetch(event.target.value)
    outlets.map((outlet) => {
      if (outlet._id == event.target.value) {
        setSelectedOutletName(outlet.name)
        return
      }
    })
  }

  if (outletFetchError) return <ErrorScreen onClick={fetchOutlet} />

  const fileList = [
    { name: 'CounterGroups.csv', desc: 'All counter group definitions.' },
    { name: 'Counters.csv', desc: 'All kitchen counter definitions.' },
    { name: 'Items.csv', desc: 'All item definitions including pricing and tax.' }
  ]

  const FileListing = () => (
    <List dense disablePadding sx={{ mt: 1 }}>
      {fileList.map((f) => (
        <ListItem key={f.name} disableGutters sx={{ alignItems: 'flex-start' }}>
          <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
            <InsertDriveFileOutlined fontSize="small" color="action" />
          </ListItemIcon>
          <ListItemText
            primary={f.name}
            secondary={f.desc}
            primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
            secondaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
          />
        </ListItem>
      ))}
    </List>
  )

  const handleImportClick = () => {
    if (selectedOutlet) {
      setItemsDrawerVisibility(true)
      setItem(undefined)
    } else {
      toastMessage('Select Outlet', 'warning')
    }
  }

  const handleExportClick = () => {
    if (selectedOutlet) {
      setCounterGroupsArray([])
      setCountersArray([])
      setItemArray([])
      setPageCounterGroup(1)
      setPageCounter(1)
      setPageItem(1)
      setCounterGroupFileExport('CounterGroups.csv exporting...')
      setCounterFileExport('Counters.csv exporting...')
      setItemFileExport('Items.csv exporting...')
      setStatusIconCGExport(<CircularProgress size={20} />)
      setStatusIconCExport(<CircularProgress size={20} />)
      setStatusIconItemExport(<CircularProgress size={20} />)
      setExportDataStatus(true)
      setFileExportVisibility(true)
      setExportSubmitButtonDisabled(true)
      const payload = {
        outlet_id: selectedOutlet,
        pageNumber: 1,
        limit: limit
      }
      fetchCounterGroups(payload)
      kitchenCountersFetch(payload)
      fetchItems(payload)
    } else {
      toastMessage('Select Outlet', 'warning')
    }
  }

  const cardActionStyles = {
    borderRadius: 2,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: 'primary.main',
      boxShadow: (theme) => `0 4px 16px ${theme.palette.action.hover}`
    }
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Helmet title="Bulk Upload" />

      {/* Page header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          Bulk Upload
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Import or export counter groups, kitchen counters and items in CSV format.
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />

      {outletFetchLoading ? (
        <ListTypeShimmer />
      ) : (
        <>
          {/* Outlet selector — left-aligned, fixed width */}
          <Box sx={{ mb: 3, maxWidth: 360 }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5, mb: 1, display: 'block' }}>
              Outlet
            </Typography>
            <TextField
              size="small"
              id="outlet"
              name="outlet"
              variant="outlined"
              value={selectedOutlet}
              onChange={handleOutletChange}
              select
              fullWidth
              disabled={outlets.length === 0}
              placeholder="Select an outlet"
            >
              {outlets.map((outlet) => (
                <MenuItem key={outlet._id} value={outlet._id}>
                  {outlet.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Grid container spacing={3}>
            {/* Import card */}
            <Grid item xs={12} md={6}>
              <Card variant="outlined" sx={cardActionStyles}>
                <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                      color: 'primary.main'
                    }}
                  >
                    <FileDownload />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Import
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Upload CSV files to update this outlet.
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <CardContent sx={{ flex: 1, px: 3, py: 2 }}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Files Required
                  </Typography>
                  <FileListing />
                </CardContent>
                <Box sx={{ px: 3, pb: 3 }}>
                  <Button
                    startIcon={<FileDownload />}
                    variant="contained"
                    fullWidth
                    onClick={handleImportClick}
                    sx={{ textTransform: 'none', fontWeight: 600, py: 1 }}
                  >
                    Import Files
                  </Button>
                </Box>
              </Card>
            </Grid>

            {/* Export card */}
            <Grid item xs={12} md={6}>
              <Card variant="outlined" sx={cardActionStyles}>
                <Box sx={{ p: 3, pb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: 1.5,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: (theme) => alpha(theme.palette.success.main, 0.1),
                      color: 'success.main'
                    }}
                  >
                    <FileUpload />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Export
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Download the current data as CSV files.
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <CardContent sx={{ flex: 1, px: 3, py: 2 }}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    Files Generated
                  </Typography>
                  <FileListing />
                </CardContent>
                <Box sx={{ px: 3, pb: 3 }}>
                  <Button
                    startIcon={<FileUpload />}
                    variant="contained"
                    color="success"
                    fullWidth
                    onClick={handleExportClick}
                    sx={{ textTransform: 'none', fontWeight: 600, py: 1 }}
                  >
                    Export Files
                  </Button>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* Workflow note */}
          <Box
            sx={{
              mt: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(33,150,243,0.08)' : 'rgba(33,150,243,0.06)',
              border: 1,
              borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(33,150,243,0.2)' : 'rgba(33,150,243,0.15)',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5
            }}
          >
            <InfoOutlined fontSize="small" color="info" sx={{ mt: 0.25 }} />
            <Typography variant="body2" color="text.secondary">
              <strong style={{ color: 'inherit' }}>Recommended workflow:</strong> first export the CSV files, modify them externally, then import the updated files back.
            </Typography>
          </Box>
        </>
      )}

      <FileImportDialog
        initialValue={userdata}
        visible={fileImportVisibility}
        counterGroupMsg={counterGroupFile}
        countersMsg={counterFile}
        itemsMsg={itemFile}
        counterGroupIcon={statusIconCG}
        countersIcon={statusIconC}
        itemsIcon={statusIconItem}
        submitDisabled={submitButtonDisabled}
        snackbarStatus={snackbar}
        snackbarMsg={PopUpMessage}
        snackbarSeverity={severity}
        okSubmit={() => {
          setStatusIconCG(<CircularProgress size={20} />)
          setStatusIconC(<CircularProgress size={20} />)
          setStatusIconItem(<CircularProgress size={20} />)
          setSubmitButtonDisabled(true)
          setCounterGroupFile('CounterGroups.csv importing...')
          setCounterFile('Counters.csv importing...')
          setItemFile('Items.csv importing...')
        }}
        snackbarClose={() => {
          setSnackBar(false)
        }}
        onClose={() => setFileImportVisibility(false)}
      />

      <ImportDialog
        outlet={selectedOutletName}
        visible={itemDrawerVisibility}
        initialValue={userdata}
        onClose={() => {
          setItemsDrawerVisibility(false)
          setSubmitButtonDisabled(true)
          setBackButtonDisabled(true)
          setCounterGroupMsg(null)
          setCounterMsg(null)
          setItemMsg(null)
          setSelectedFolder(null)
          setStockUpdateStatus(false)
          setFileStatusIconCG(
            <Verified
              fontSize="small"
              color="primary"
              sx={{ alignItems: 'center' }}
            />
          )
          setFileStatusIconC(
            <Verified
              fontSize="small"
              color="primary"
              sx={{ alignItems: 'center' }}
            />
          )
          setFileStatusIconItem(
            <Verified
              fontSize="small"
              color="primary"
              sx={{ alignItems: 'center' }}
            />
          )
        }}
        fileStatusIconCG={fileStatusIconCG}
        fileStatusIconC={fileStatusIconC}
        fileStatusIconItem={fileStatusIconItem}
        selectedFolder={selectedFolder}
        counterGroupFile={counterGroupMsg}
        counterFile={counterMsg}
        itemFile={itemMsg}
        backButtonDisabled={backButtonDisabled}
        submitButtonDisabled={submitButtonDisabled}
        fileVerification={(e) => {
          let count = 0
          const files = e.target.files
          let counterGroupFile
          let counterFile
          let itemFile
          for (let i = 0; i < files.length; i++) {
            if (count == 3) {
              break
            }
            if (files[i].name === 'CounterGroups.csv') {
              count++
              counterGroupFile = files[i]
            }
            if (files[i].name === 'Counters.csv') {
              count++
              counterFile = files[i]
            }
            if (files[i].name === 'Items.csv') {
              count++
              itemFile = files[i]
            }
          }

          if (!checkFileType(counterGroupFile, ['CounterGroups.csv'])) {
            setCounterGroupMsg('CounterGroups.csv not found')
            setFileStatusIconCG(<Error fontSize="small" color="error" />)
            setBackButtonDisabled(false)
            e.target.value = null
            return
          }
          setCounterGroupMsg('CounterGroups.csv found.')

          if (!checkFileType(counterFile, ['Counters.csv'])) {
            setCounterMsg('Counters.csv not found')
            setFileStatusIconC(<Error fontSize="small" color="error" />)
            setBackButtonDisabled(false)
            e.target.value = null
            return
          }
          setCounterMsg('Counters.csv found')

          if (!checkFileType(itemFile, ['Items.csv'])) {
            setItemMsg('Items.csv not found')
            setFileStatusIconItem(<Error fontSize="small" color="error" />)
            setBackButtonDisabled(false)
            e.target.value = null
            return
          }
          setItemMsg('Items.csv found')
          setSubmitButtonDisabled(false)
          setBackButtonDisabled(true)

          if (files.length > 0) {
            const folderPath = files[0].webkitRelativePath.split('/')[0]
            setSelectedFolder(folderPath)
          }

          try {
            const reader = new FileReader()
            reader.onload = function (event) {
              const data = event.target.result
              const workbook = XLSX.read(data, { type: 'binary' })
              const sheetName = workbook.SheetNames[0]
              const sheet = workbook.Sheets[sheetName]
              const json = XLSX.utils.sheet_to_json(sheet, { raw: false })
              const refinedJson = json.map((item) => {
                const newItem = {
                  name: item['CounterGroup Name']
                }

                if (item.Id) {
                  newItem._id = BigInt(item.Id.substring(1, item.Id.length - 1))
                }
                return newItem
              })
              setJson_CounterGroups({
                outlet_id: selectedOutlet,
                counters_groups: [...refinedJson]
              })
              const expectedKeys = ['CounterGroup Name', 'Id']

              const keys = Object.keys(json[0])
              const isCorrect = keys.every((key) => expectedKeys.includes(key))
              if (isCorrect) {
                setCounterGroupMsg('CounterGroups.csv verified')
              } else {
                setCounterGroupMsg('CounterGroups.csv not verified')
                setFileStatusIconCG(<Error fontSize="small" color="error" />)
                setBackButtonDisabled(false)
                setSubmitButtonDisabled(true)
              }
            }

            const reader2 = new FileReader()
            reader2.onload = function (event) {
              const data = event.target.result
              const workbook = XLSX.read(data, { type: 'binary' })
              const sheetName = workbook.SheetNames[0]
              const sheet = workbook.Sheets[sheetName]
              const json = XLSX.utils.sheet_to_json(sheet, { raw: false })
              const refinedJson = json.map((item) => {
                const newItem = {
                  name: item['KitchenCounters Name'],
                  counter_group: item['CounterGroup Name'],
                  printer_number: item['Printer Number']
                    ? Number(item['Printer Number'])
                    : 0
                }
                if (item.Id) {
                  newItem._id = BigInt(item.Id.substring(1, item.Id.length - 1))
                }
                return newItem
              })
              setJson_Counter({
                outlet_id: selectedOutlet,
                counters: [...refinedJson]
              })
              const expectedKeys = [
                'KitchenCounters Name',
                'CounterGroup Name',
                'Printer Number',
                'Id'
              ]
              const keys = Object.keys(json[0])
              const isCorrect = keys.every((key) => expectedKeys.includes(key))
              if (isCorrect) {
                setCounterMsg('Counters.csv verified')
              } else {
                setCounterMsg('Counters.csv not verified')
                setFileStatusIconC(<Error fontSize="small" color="error" />)
                setSubmitButtonDisabled(true)
                setBackButtonDisabled(false)
              }
            }

            const reader3 = new FileReader()

            reader3.onload = function (event) {
              const data = event.target.result
              const workbook = XLSX.read(data, { type: 'binary' })
              const sheetName = workbook.SheetNames[0]
              const sheet = workbook.Sheets[sheetName]
              const json = XLSX.utils.sheet_to_json(sheet, { raw: false })
              const headerRow = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0] || []
              const hasCommissionColumn = headerRow.includes('Commission')

              const validateCommission = (rawValue, rowNumber) => {
                if (
                  rawValue === undefined ||
                  rawValue === null ||
                  String(rawValue).trim() === ''
                ) {
                  return { value: 0, error: null }
                }
                const strValue = String(rawValue).trim()
                const numValue = Number(strValue)
                if (!Number.isFinite(numValue)) {
                  return {
                    value: null,
                    error: `Items.csv row ${rowNumber}: invalid commission "${strValue}". Must be a number between 0 and 100 with up to 2 decimal places.`
                  }
                }
                if (numValue < 0 || numValue > 100) {
                  return {
                    value: null,
                    error: `Items.csv row ${rowNumber}: commission "${strValue}" out of range. Allowed range is 0 to 100.`
                  }
                }
                const decimalMatch = strValue.match(/\.(\d+)$/)
                if (decimalMatch && decimalMatch[1].length > 2) {
                  return {
                    value: null,
                    error: `Items.csv row ${rowNumber}: commission "${strValue}" has more than 2 decimal places.`
                  }
                }
                return { value: numValue, error: null }
              }

              const commissionErrors = []

              const refinedJson = json.map((item, index) => {
                const newItem = {
                  name: item['Item Name'],
                  sku: item['SKU'] ? item['SKU'] : '',
                  unit: item['Unit'] ? item['Unit'] : 'PCS',
                  delete_status: false,
                  parcel_amt: item['Parcel Charge']
                    ? Number(item['Parcel Charge'])
                    : 0,
                  price: [
                    {
                      unit_price: item['Price1'] ? Number(item['Price1']) : 0,
                      cgst: item['CGST1'] ? Number(item['CGST1']) : 0,
                      sgst: item['SGST1'] ? Number(item['SGST1']) : 0,
                      cess1: item['Cess1'] ? Number(item['Cess1']) : 0,
                      cess2: item['Cess2'] ? Number(item['Cess2']) : 0,
                      cost_price: item['Cost Price']
                        ? Number(item['Cost Price'])
                        : 0,
                      igst: 0,
                      discount_percentage: 0,
                      discount_value: 0,
                      price_id: 1
                    },
                    {
                      unit_price: item['Price2'] ? Number(item['Price2']) : 0,
                      cgst: item['CGST2'] ? Number(item['CGST2']) : 0,
                      sgst: item['SGST2'] ? Number(item['SGST2']) : 0,
                      cess1: item['Cess1'] ? Number(item['Cess1']) : 0,
                      cess2: item['Cess2'] ? Number(item['Cess2']) : 0,
                      cost_price: item['Cost Price']
                        ? Number(item['Cost Price'])
                        : 0,
                      igst: 0,
                      discount_percentage: 0,
                      discount_value: 0,
                      price_id: 2
                    },
                    {
                      unit_price: item['Price3'] ? Number(item['Price3']) : 0,
                      cgst: item['CGST3'] ? Number(item['CGST3']) : 0,
                      sgst: item['SGST3'] ? Number(item['SGST3']) : 0,
                      cess1: item['Cess1'] ? Number(item['Cess1']) : 0,
                      cess2: item['Cess2'] ? Number(item['Cess2']) : 0,
                      cost_price: item['Cost Price']
                        ? Number(item['Cost Price'])
                        : 0,
                      igst: 0,
                      discount_percentage: 0,
                      discount_value: 0,
                      price_id: 3
                    }
                  ],
                  kitchen_counter: item['Kitchen Counter'],
                  image_path: item['Imagepath'] ? item['Imagepath'] : '',
                  stock: item['Stock'] ? Number(item['Stock']) : 0,
                  maintain_inventory: Number(item['Maintain Inventory'])
                    ? true
                    : false,
                  weighing_scale_code:
                    Number(item['Weighing Scale Code']) === 1
                      ? Number(item['Weighing Scale Code'])
                      : 0,
                  is_favorite: Number(item['Is Favorite']) === 1 ? true : false,
                  priority: item['Priority(0,1,2,3,4,5)'] ? Number(item['Priority(0,1,2,3,4,5)']) : 0
                }

                if (hasCommissionColumn) {
                  const result = validateCommission(item['Commission'], index + 2)
                  if (result.error) {
                    commissionErrors.push(result.error)
                  }
                  newItem.commission = result.value !== null ? result.value : 0
                }

                if (item.Id) {
                  newItem._id = BigInt(item.Id.substring(1, item.Id.length - 1))
                }
                if (terminalSettingsFetchData?.inventory_status) {
                  if (item['Stock'] > 0) {
                    setStockUpdateDailog(true)
                  }
                }

                return newItem
              })
              setJson_Item({
                outlet_id: selectedOutlet,
                items: [...refinedJson]
              })
              const expectedKeys = [
                'Item Name',
                'SKU',
                'Cost Price',
                'Unit',
                'Parcel Charge',
                'Price1',
                'SGST1',
                'CGST1',
                'Price2',
                'CGST2',
                'SGST2',
                'Price3',
                'CGST3',
                'SGST3',
                'Cess1',
                'Cess2',
                'Kitchen Counter',
                'Imagepath',
                'Stock',
                'Maintain Inventory',
                'Weighing Scale Code',
                'Is Favorite',
                'Priority(0,1,2,3,4,5)',
                'Commission',
                'Id'
              ]

              const keys = Object.keys(json[0])
              const isCorrect = keys.every((key) => expectedKeys.includes(key))
              if (!isCorrect) {
                setItemMsg('Items.csv not verified')
                setFileStatusIconItem(<Error fontSize="small" color="error" />)
                setSubmitButtonDisabled(true)
                setBackButtonDisabled(false)
              } else if (commissionErrors.length > 0) {
                setItemMsg(commissionErrors.join('; '))
                setFileStatusIconItem(<Error fontSize="small" color="error" />)
                setSubmitButtonDisabled(true)
                setBackButtonDisabled(false)
              } else {
                setItemMsg('Items.csv verified')
              }
            }

            reader.readAsBinaryString(counterGroupFile)
            reader2.readAsBinaryString(counterFile)
            reader3.readAsBinaryString(itemFile)
          } catch (e) {
            toastMessage('Error', 'error')
          }
        }}
        onImport={async () => {
          setFileImportVisibility(true)
          await importCounterGroup(
            json_CounterGroup,
            async (success, error, message) => {
              if (error) {
                let errorMessage =
                  message || 'Error while creating CounterGroup. Try again'
                toastMessage(errorMessage, 'error')
                setCounterGroupFile('CounterGroup.csv importing failed')
                setCounterFile('Counters.csv importing failed')
                setItemFile('Items.csv importing failed')
                setSubmitButtonDisabled(false)
                setStatusIconCG(
                  <Error
                    fontSize="small"
                    color="error"
                    sx={{ alignItems: 'center' }}
                  />
                )
                setStatusIconC(
                  <Error
                    fontSize="small"
                    color="error"
                    sx={{ alignItems: 'center' }}
                  />
                )
                setStatusIconItem(
                  <Error
                    fontSize="small"
                    color="error"
                    sx={{ alignItems: 'center' }}
                  />
                )
              } else {
                toastMessage('CounterGroup created', 'success')
                setCounterGroupFile('CounterGroup.csv imported')
                setStatusIconCG(
                  <CheckCircle fontSize="small" color="success" />
                )
                await kitchenCountersImport(
                  json_Counter,
                  async (success, error, message) => {
                    if (error) {
                      let errorMessage =
                        message ||
                        'Error while creating Kitchen Counter. Try again'
                      toastMessage(errorMessage, 'error')
                      setCounterFile('Counters.csv importing failed')
                      setStatusIconC(
                        <Error
                          fontSize="small"
                          color="error"
                          sx={{ alignItems: 'center' }}
                        />
                      )
                      setItemFile('Items.csv importing failed')
                      setStatusIconItem(
                        <Error
                          fontSize="small"
                          color="error"
                          sx={{ alignItems: 'center' }}
                        />
                      )
                      setSubmitButtonDisabled(false)
                    } else {
                      toastMessage('Kitchen Counter created', 'success')
                      setCounterFile('Counters.csv imported')
                      setStatusIconC(
                        <CheckCircle fontSize="small" color="success" />
                      )
                      json_Item['updateStock'] = stockUpdateStatus
                      importItemsCsv(
                        json_Item,
                        async (success, error, message) => {
                          if (error) {
                            let errorMessage =
                              message || 'Error while creating Item. Try again'
                            toastMessage(errorMessage, 'error')
                            setItemFile('Items.csv importing failed')
                            setStatusIconItem(
                              <Error
                                fontSize="small"
                                color="error"
                                sx={{ alignItems: 'center' }}
                              />
                            )
                            setSubmitButtonDisabled(false)
                          } else {
                            setSubmitButtonDisabled(false)
                            toastMessage('Item created', 'success')
                            setItemFile('Items.csv imported')
                            setStatusIconItem(
                              <CheckCircle fontSize="small" color="success" />
                            )
                          }
                        }
                      )
                    }
                  }
                )
              }
            }
          )
        }}
      />
      <FileExportDialog
        initialValue={userdata}
        visible={fileExportVisibility}
        counterGroupsMsg={counterGroupFileExport}
        countersMsg={counterFileExport}
        itemsMsg={itemFileExport}
        counterGroupsIcon={statusIconCGExport}
        countersIcon={statusIconCExport}
        itemsIcon={statusIconItemExport}
        okButtonStatus={exportSubmitButtonDisabled}
        okSubmit={() => {
          setCounterGroupFileExport('CounterGroups.csv exporting...')
          setCounterFileExport('Counters.csv exporting...')
          setItemFileExport('Items.csv exporting...')
          setStatusIconCGExport(<CircularProgress size={20} />)
          setStatusIconCExport(<CircularProgress size={20} />)
          setStatusIconItemExport(<CircularProgress size={20} />)
          setItemArray([])
          setCounterGroupsArray([])
          setCountersArray([])
          setStockUpdateStatus(false)
          setPageCounterGroup(1)
          setPageCounter(1)
          setPageItem(1)
        }}
        onClose={() => {
          setFileExportVisibility(false)
          setItemArray([])
          setCounterGroupsArray([])
          setCountersArray([])
          setPageCounterGroup(1)
          setPageCounter(1)
          setPageItem(1)
          setExportDataStatus(false)
        }}
      />
      <ConfirmationDialog
        visibility={stockUpdateDailog}
        title={'Confirmation'}
        note={'Do you want to update stock?'}
        okText={'Yes'}
        cancelText={'No'}
        onOkColor={'primary'}
        onOk={() => {
          setStockUpdateStatus(true)
          setStockUpdateDailog(false)
        }}
        onCancel={() => {
          setStockUpdateStatus(false)
          setStockUpdateDailog(false)
        }}
      />
      <Snackbar
        open={snackbar}
        autoHideDuration={SnackBarHideDuration}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}
        TransitionComponent={SnackBarTransition}
      >
        <Alert onClose={handleSnackbarClose} severity={severity}>
          {PopUpMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default bulkUpload
